import { ICoupon } from 'features/billing/couponInfo/couponInfoTypes';
import { paymentsClient } from '../axiosInstance';

const couponsURL = process.env.REACT_APP_PAYMENTS_API + '/coupons'

export const fetchCouponById = async (couponId: string) => {
    return await paymentsClient.get<ICoupon>(couponsURL + `/${couponId}`);
}

export const fetchCouponByPromotionCode = async (promotionCode: string) => {
    return await paymentsClient.get<ICoupon>(couponsURL + `/promotion-codes/${promotionCode}`);
}